// import $ from 'jquery';
import _ from 'lodash'
import { toggleLoading } from '../actions/defaultActions'
import config from '../store/_config'
import { default as STORE } from '../store/store'
import { saveSupplierActiveCustomerToStorage } from '../store/localStorage'
import { axiosInstance as axios, handleAxiosErrors } from '_utils'
import { convertActiveCustomerToReact, convertMemberNamesToReactSelect } from '../selectors/converterSelectors'
import $ from 'jquery'
import { createAlert } from '../../main/dom/window'
import { reset } from '../../main/dom/form'
import { buildRequestProductListParams } from '../../main/selectors/defaultSelectors'
import { updateOngoingDealData } from './ongoingDealsActions'
import { requestPermanentBackOrder } from '../actions/permanentBackorderActions'
import { requestFromServer as supplierRequestFromServer } from '../actions/cartSupplierActions'
import { getUserWarehouseCode, triggerDiscount } from '../actions/userActions'
import { LS } from '../store/localStorage'
import { getUserCredentials } from './userActions'

// TODO: dynamic url (fetchURL)
//       - removeOrderTemplate

/**
 * Update Active Customer Name Input
 *
 * @param selectedOption
 * @returns {{type: string, value: *}}
 */
export const updateActiveCustomerName = (value) => {
  return {
    type: 'UPDATE_ACTIVE_CUSTOMER_NAME',
    value: value,
  }
}

export const updateActive3PLCustomerName = (value) => {
  return {
    type: 'UPDATE_ACTIVE_3PL_CUSTOMER_NAME',
    value: value,
  }
}

/**
 * Update Active Customer Object
 *
 * @param value
 * @returns {{type: string, value: *}}
 */
export const updateActiveCustomer = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_ACTIVE_CUSTOMER',
      value: value,
    })
  }
}

/**
 * Reset Active Customer Object to its default state
 *
 * @returns {Function}
 */
export const resetActiveCustomer = () => {
  return (dispatch, getState) => {
    dispatch({
      type: 'RESET_ACTIVE_CUSTOMER',
    })
  }
}

/**
 * Send a request to submit orderOnBehalf, once we get the response, assign the customer
 *
 * @param activeCustomer
 * @returns {function(*, *): Promise<T>}
 */
export const submitOrderOnBehalfOf = (activeCustomer) => {
  return (dispatch, getState) => {
    const store = getState()

    if (store.isLoading) {
      return
    }

    dispatch(toggleLoading(true))
    console.log('activeCustomer ==========', { activeCustomer })
    const customerID = typeof activeCustomer.value != 'undefined' ? activeCustomer.value : 0

    let { url, query } = config.members.orderOnBehalf

    return axios
      .post(
        url,
        {
          query: query,
          variables: {
            MemberID: customerID,
          },
        },
        {
          withCredentials: true,
        }
      )
      .then(async (response) => {
        dispatch(toggleLoading(false))

        const orderOnBehalfData = response?.data?.data?.orderOnBehalf

        if (orderOnBehalfData) {
          await dispatch(triggerDiscount(customerID))

          const customer = convertActiveCustomerToReact(orderOnBehalfData)

          dispatch(updateActiveCustomer(customer))
          // dispatch(resetActiveCustomer())

          const warehouseCode = orderOnBehalfData?.Warehouse?.Code

          dispatch(getUserWarehouseCode(warehouseCode))
          const customerDropdown = convertMemberNamesToReactSelect([orderOnBehalfData])
          dispatch(updateOngoingDealData('assignedCustomers', customerDropdown))

          saveSupplierActiveCustomerToStorage(STORE, customer.id)

          Promise.all([
            dispatch(getUserCredentials()),
            dispatch(supplierRequestFromServer()),
            dispatch(requestPermanentBackOrder()),
          ]).then(() => {
            $('#customer-modal').modal('hide')
          })
        } else {
          console.log('Invalid response')
        }
      })
      .catch((error) => {
        dispatch(toggleLoading(false))
        handleAxiosErrors(error)
      })

    // $.ajax({
    //     type: 'POST',
    //     url: url,
    //     data: data,
    //     cache: false,
    //     dataType: 'json',
    //     success: function (response) {
    //
    //         dispatch(toggleLoading(false));
    //
    //         if(response.status) {
    //             const customer = convertActiveCustomerToReact(activeCustomer.original);
    //             dispatch(updateActiveCustomer(customer));
    //
    //             $('#customer-modal').modal('hide');
    //         }
    //         else {
    //             console.log('Invalid response');
    //         }
    //
    //     },
    //     error: function (response) {
    //         // create alert
    //         createAlert(response, 'error');
    //         // remove loader
    //         dispatch(toggleLoading(false));
    //     }
    // });
  }
}

export const submitOrderOnBehalfOf3pl = (activeCustomer, location) => {
  return (dispatch, getState) => {
    const store = getState()

    if (store.isLoading) {
      return
    }

    dispatch(toggleLoading(true))
    console.log('activeCustomer ==========', { activeCustomer, location })
    const customerID = typeof activeCustomer.value != 'undefined' ? activeCustomer.value : 0
    const locationId = typeof location != 'undefined' ? +location : 0

    let { url, query } = config.members.orderOnBehalf

    return axios
      .post(
        url,
        {
          query: query,
          variables: {
            MemberID: customerID,
            LocationID: locationId,
          },
        },
        {
          withCredentials: true,
        }
      )
      .then(async (response) => {
        dispatch(toggleLoading(false))

        const orderOnBehalfData = response?.data?.data?.orderOnBehalf

        if (orderOnBehalfData) {
          window.currentWarehouseID = locationId
          await dispatch(triggerDiscount(customerID))

          const customer = convertActiveCustomerToReact(orderOnBehalfData)

          dispatch(updateActiveCustomer(customer))

          const warehouseCode = orderOnBehalfData?.Warehouse?.Code

          dispatch(getUserWarehouseCode(warehouseCode))
          const customerDropdown = convertMemberNamesToReactSelect([orderOnBehalfData])
          dispatch(updateOngoingDealData('assignedCustomers', customerDropdown))

          saveSupplierActiveCustomerToStorage(STORE, customer.id)
          dispatch(toggleThreePlSubmitStatus(true))
          Promise.all([dispatch(supplierRequestFromServer()), dispatch(requestPermanentBackOrder())]).then(() => {
            $('#customer-modal').modal('hide')
          })
        } else {
          console.log('Invalid response')
        }
      })
      .catch((error) => {
        dispatch(toggleLoading(false))
        handleAxiosErrors(error)
      })
      .finally(() => {
        dispatch(toggleThreePlSubmitStatus(false))
      })
  }
}

export const toggleThreePlSubmitStatus = (value) => {
  return {
    type: 'TOGGLE_THREE_PL_SUBMIT_STATUS',
    value: value,
  }
}
